import { ts } from "cessnalib";
import { Exception, Log, Particle } from "../../particle";

export interface Nucleus {
    log(message: string, level: Log["level"]): void;
}

export interface ListOptions {
    offset?: number;
    limit?: number;
    order?: "asc" | "desc";
    orderBy?: string;
}

export type MongoOperator = "$eq" | "$ne" | "$gt" | "$gte" | "$lt" | "$lte" | "$in" | "$nin" | "$exists" | "$type" | "$regex" | "$where" | "$elemMatch" | "$all" | "$size";

export type Query<T> = {
    [P in keyof T]?: (T[P] extends object ? Query<T[P]> : T[P]) | ts.array.GetSingleKeyObjectFromUnion<MongoOperator, T[P]>
}

export abstract class Vacuole {
    constructor(protected nucleus: Nucleus) { }
    abstract getAlive(): Promise<void | Exception>;
    //Convert this method in order to return only single object, use list for multiple
    abstract read<T extends Particle>(query: Query<T>, count?: number | "All"): Promise<T[] | Exception>;
    abstract list<T extends Particle>(query: Query<T>, options?: ListOptions): Promise<T[] | Exception>;
    abstract save<T extends Particle>(particle: T, query?: Query<T>, count?: number | "All"): Promise<void | Exception>;
    abstract saveAll<T extends Particle>(particles: T[]): Promise<void | Exception>;
    abstract remove<T extends Particle>(query: Query<T>, count?: number | "All"): Promise<void | Exception>;
}